export const enum ACTION {
  UPDATE_IS_BROWSER_NAVIGATION = "UPDATE_IS_BROWSER_NAVIGATION",
}
